import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PublicConstants } from '../../public.constants';
import { PublicService } from '../../services/public.service';

@Component({
    selector: 'app-supplier-landing-page',
    templateUrl: './supplier-landing-page.component.html',
    styleUrls: ['./supplier-landing-page.component.scss'],
    standalone: false
})
export class SupplierLandingPageComponent implements OnInit {

  data: object;
  loadRegister = false;
  constructor(private translate: TranslateService, private router: Router,
    private _service: PublicService, private _route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this._route.queryParams.subscribe(params => {
      if (params && params.referralCode) {
        this._service.getInviteDetails(params.referralCode).toPromise()
          .then(resp => {
            this.data = {
              email: resp['supplierEmail'],
              name: resp['supplierName'],
              referralCode: params.referralCode
            };
            this.loadRegister = true;
          })
          .catch(err => {
            this._service.openSnackBar((err.error) ? err.error.message : err.message);
            this.loadRegister = true;
          });
      } else {
        this.loadRegister = true;
      }
    });
  }

  goToLogin() {
    this._service.goToLogin();
  }
}

